import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { BulkSettingsUpdate } from 'OpsCenter/ops-support/settings/bulk-settings-update';

@Injectable()
export class BulkSettingsService {
  private BASE_URL = 'oc-api/operations/merchants-bulk-management';

  constructor(private http: HttpClient) {
  }

  updateLeadTimes(ids: BulkSettingsUpdate): Observable<any> {
    return this.http.put(this.BASE_URL + '/settings/lead-times', ids);
  }

  updateMaxReservationSize(ids: BulkSettingsUpdate): Observable<any> {
    return this.http.put(this.BASE_URL + '/settings/max-reservation-size', ids);
  }

  updateAutomaticConfirmation(ids: BulkSettingsUpdate): Observable<any> {
    return this.http.put(this.BASE_URL + '/settings/reservation-auto-confirmation', ids);
  }

  updateCutoffTimes(ids: BulkSettingsUpdate): Observable<any> {
    return this.http.put(this.BASE_URL + '/cut-off-times', ids);
  }

  updateCoverLimits(ids: BulkSettingsUpdate): Observable<any> {
    return this.http.put(this.BASE_URL + '/cover-limits', ids);
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/settings/bulk-settings.service.ts